import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { FlashDeals } from "@/components/FlashDeals";

const HERO = "https://images.unsplash.com/photo-1677753670021-123aba554171?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

const Hero = () => (
  <section className="grid grid-cols-1 md:grid-cols-12 border-b border-[#0F0F0F]">
    <div className="md:col-span-7 p-6 md:p-12 lg:p-16 md:border-r border-[#0F0F0F] flex flex-col justify-between gap-10">
      <span className="tag text-[#FF3333]">Offerte selezionate · aggiornate ogni giorno</span>
      <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
        I migliori prezzi,<br />consegnati a<br />casa tua.
      </h1>
      <p className="text-base md:text-lg font-light text-[#555] max-w-md">
        Selezioniamo ogni giorno i prodotti in sconto più interessanti. Ordini in un minuto, senza registrazione. Spedizione gratuita.
      </p>
    </div>
    <div className="md:col-span-5 relative min-h-[280px] grain overflow-hidden">
      <img src={HERO} alt="Pacchi" className="absolute inset-0 w-full h-full object-cover" />
    </div>
  </section>
);

const Marquee = () => (
  <div className="border-b border-[#0F0F0F] bg-[#0F0F0F] text-white overflow-hidden py-2">
    <div className="marquee flex whitespace-nowrap w-max">
      {Array.from({ length: 2 }).map((_, k) => (
        <span key={k} className="tag px-4">
          Spedizione gratuita &nbsp;/&nbsp; Pagamento sicuro &nbsp;/&nbsp; Consegna diretta &nbsp;/&nbsp; Nessuna registrazione &nbsp;/&nbsp; Reso facile &nbsp;/&nbsp; Spedizione gratuita &nbsp;/&nbsp; Pagamento sicuro &nbsp;/&nbsp; Consegna diretta &nbsp;/&nbsp;
        </span>
      ))}
    </div>
  </div>
);

export default function Home() {
  const [products, setProducts] = useState([]);
  const [cats, setCats] = useState([]);
  const [cat, setCat] = useState("");
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)); }, []);
  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/products", { params: { category: cat || undefined, q: q || undefined } }).then((r) => setProducts(r.data));
    }, 250);
    return () => clearTimeout(t);
  }, [cat, q]);

  return (
    <main data-testid="home-page">
      <Hero />
      <FlashDeals />
      <Marquee />
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <span className="tag text-[#555]">Catalogo</span>
            <h2 className="font-display font-extrabold text-3xl md:text-4xl tracking-tight mt-1">Offerte del giorno</h2>
          </div>
          <div className="relative w-full md:w-80">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#555]" />
            <input data-testid="search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca un prodotto" className="field" style={{ paddingLeft: "2.25rem" }} />
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mb-8">
          {["", ...cats].map((c) => (
            <button
              key={c || "all"}
              data-testid={`category-filter-${c || "tutti"}`}
              onClick={() => setCat(c)}
              className={`tag px-3 py-2 border border-[#0F0F0F] ${cat === c ? "bg-[#0F0F0F] text-white" : "hover:bg-[#0F0F0F] hover:text-white"}`}
            >
              {c || "Tutti"}
            </button>
          ))}
        </div>
        {products.length === 0 ? (
          <p className="text-[#555]" data-testid="no-products">{q || cat ? "Nessun prodotto trovato." : "Nuove offerte in arrivo: torna a trovarci tra poco!"}</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="product-grid">
            {products.map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
          </div>
        )}
      </section>
    </main>
  );
}
